import { render, staticRenderFns } from "./ShipmentDetails.vue?vue&type=template&id=420dfc5c&"
import script from "./ShipmentDetails.vue?vue&type=script&lang=js&"
export * from "./ShipmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentDetails.vue?vue&type=style&index=0&id=420dfc5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports